import React, { useEffect, useState } from "react";
import RegisterCard from "./RegisterCard";
import SuccessCard from "./SuccessCard";
import { Stepper } from "react-form-stepper";
import SectionMain from "../SectionMain";

const PlansForm = () => {
  const [formStep, setFormStep] = useState(0);
  const [subsResponse, setSubsResponse] = useState(null);
  const [formUser, setFormUser] = useState({
    email: localStorage.getItem("emailActive") || "",
    password: localStorage.getItem("passActive") || "",
    id: localStorage.getItem("idActive") || "",
  });

  const id = localStorage.getItem("id");
  const [state, setState] = useState({
    step: formUser.id ? 2 : 1,
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    courses: [],
    level: "",
    isErrorFirstName: true,
    isErrorLastName: true,
    errorMessageFirstName: "",
    errorMessageLastName: "",
  });

  const nextStep = () => {
    setState({ ...state, step: state.step + 1 });
  };

  const prevStep = () => {
    setState({ ...state, step: state.step - 1 });
  };

  const renderContent = () => {
    switch (state.step) {
      case 1:
        return (
          <RegisterCard
            nextStep={nextStep}
            prevStep={prevStep}
            step={state.step}
            setFormStep={setFormStep}
            register={false}
            setSubsResponse={setSubsResponse}
          />
        );
      case 2:
        return (
          <SuccessCard
            nextStep={nextStep}
            prevStep={prevStep}
            step={state.step}
            stepFree={formStep}
            subsResponse={subsResponse}
          />
        );

      //

      default:
        return null;
    }
  };

  useEffect(() => {
    if (formStep === 1) {
      setState({ ...state, step: 4 });
    }
  }, [formStep]);

  return (
    <SectionMain noPadding>
      <SectionMain
        className={{
          padding: "0px",
          paddingLeft: "10%",
          justifyContent: "center",
        }}
        position="center"
      >
        <div
          style={{
            backgroundColor: "transparent",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: "15%",
            overflowX: "auto",
          }}
        >
          {renderContent()}
        </div>
      </SectionMain>
    </SectionMain>
  );
};

export default PlansForm;
